import * as React from "react";
import Layout from "../../components/layout";
import Seo from "../../components/seo";
// import EcoAlliance from '../../components/Eco-Alliance/EcoAlliance/EcoAlliance';
import IndustryExperts from "../../components/IndustryExperts/IndustryExperts";

const IndustryExpertsIndex = () => (
  <Layout>
    <Seo title="Home" />
    <div className="noissue-industry-experts">
      <IndustryExperts />
    </div>
  </Layout>
)

export default IndustryExpertsIndex;
